import * as requestFromServer from "./configurationApis";

// update refund -> api
export const updateRefundAction = (dataToBeSent) => async (dispatch) => {
    const response = await requestFromServer.updateRefund(dataToBeSent);
    return response
};



export const updatePlatformComissionPercentageAction = (dataToBeSent, setLoading) => async(dispatch) =>{
    setLoading(true)
    const response = await requestFromServer.updatePlatformComissionPercentage(dataToBeSent);
    if(response){
        setLoading(false)
        return response
    }
    else {
        setLoading(false)
        return null
    }
}